/* eslint-disable no-restricted-syntax */
import { FilterOps } from '../components/useractivitylogs/UserActivityLogBody';
import { globalConfig } from '../config/config';
import BaseUrls from './baseUrls';

class Urls {
  static getBackendUrl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return url;
    }
    return '';
  }

  static getFilterValuesForUserActivityLogs(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();

      return `${url}/useractivitylogs/filter-values`;
    }
    return '';
  }

  /*
    * Workspace API URLs
    */
  static deleteWorkspaceById(workspaceId: string | number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/workspace/${workspaceId}`;
    }
    return '';
  }

  static getWorkspaceById(workspaceId: string | number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/workspace/${workspaceId}`;
    }
    return '';
  }

  static getAllWorkspace(offset?: number, limit?: number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      if (limit) return `${BASE_URL}/workspace/list?limit=${limit}&offset=${offset}`;
      return `${BASE_URL}/workspace/list`;
    }
    return '';
  }

  static createWorkspace(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/workspace`;
    }
    return '';
  }

  static getWorkspaceResources(workspaceId: string, previouEndpoints: number, previouNetworks: number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}workspace/resources/${workspaceId}?itemsPerPage=12&endpoints=${previouEndpoints}&networks=${previouNetworks}`;
    }
    return '';
  }

  static editWorkspace(id: string): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/workspace/${id}`;
    }
    return '';
  }

  static addWorkspaceMemberById(workspaceId: string | number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/workspace/${workspaceId}`;
    }
    return '';
  }

  static getWorkSpaceList(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/workspace/list`;
    }
    return '';
  }

  /** Network invite aPi url */

  static getNetworkInviteList(status: number): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/networkInvite/fetch?status=${status}`;
    }
    return '';
  }

  /**
     * Network API URLs
     */
  static getNetworks(workspaceId: string | number, filterQueryString: string = ''): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/network/${workspaceId}?filter=${filterQueryString}`;
    }
    return '';
  }

  /**
     * Cloud API Urls
     */

  static getAllCloudsUsage(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/dashboard/cloud-usage/`;
    }
    return '';
  }

  static getProtocolWiseDistribution(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/dashboard/protocol-wise-distribution`;
    }
    return '';
  }

  static getSystemHealth(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/dashboard/system-health?filter='sortBy:today'`;
    }
    return '';
  }

  static getAllAlertsCount(): string {
    if (globalConfig.config) {
      const ALERT_URL = BaseUrls.getAlertsBackendUrl();
      return `${ALERT_URL}/api/v1/alert/summary`;
    }
    return '';
  }

  static getAllClouds(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/list`;
    }
    return '';
  }

  static getAuthorizedClouds(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/authorized`;
    }
    return '';
  }

  static createCloudAuthorizationById(cloudId: string | number) {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/authorize/${cloudId}`;
    }
    return '';
  }

  static getCloudInstanceTypesById(cloudId: string | number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/instance-types/${cloudId}`;
    }
    return '';
  }

  static getCloudRegionsById(cloudId: string | number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/regions/${cloudId}`;
    }
    return '';
  }

  static getAuthorizedCloudsById(cloudId: string | number): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/authorized/${cloudId}`;
    }
    return '';
  }

  static getDeleteCloudCredById(cloudId: string): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/cred/${cloudId}`;
    }
    return '';
  }

  static getDeleteApiKeyCredById(apikeyId: string, apikeyName: string): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/network/api-key/${apikeyId}/${apikeyName}`;
    }
    return '';
  }

  static getCloudList(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/list`;
    }
    return '';
  }

  static getNameAccessCloudsById(id: string): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/cloud/authorized?cloudId=${id}`;
    }
    return '';
  }

  /**
 * Get alert list
 */
  static getAlertList(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/oas/api/v1/alert/list`;
    }
    return '';
  }
  /**
     * Activity Logs API Urls
     */

  static getAccessTokenUrl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getAuthUrl();
      return `${url}/getNewToken`;
    }
    return '';
  }

  static getSignInUrl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getAuthUrl();
      return `${url}/login`;
    }
    return '';
  }

  static getLogoutUrl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getAuthUrl();
      return `${url}/logout`;
    }
    return '';
  }

  static getAllNetworkList(offset?: number, limit?: number, type?: string): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      if (limit) return `${url}/network/all?limit=${limit}&offset=${offset}&list=${type}`;
      return `${url}/network/all`;
    }
    return '';
  }

  static getUserActivityLogList({
    page, itemsPerPage, filters,
  }: { page?: number, itemsPerPage?: number, filters?: FilterOps }): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      let baseurl = `${url}/useractivitylogs`;
      if ((page && itemsPerPage) || filters) baseurl += '?';
      if (page && itemsPerPage) baseurl += `page=${page}&items=${itemsPerPage}`;
      if (filters) {
        const filtersString = JSON.stringify(filters);
        if ((page && itemsPerPage)) baseurl += `&filters=${filtersString}`;
        else baseurl += `filters=${filtersString}`;
      }

      return baseurl;
    }
    return '';
  }

  static createApiCredURl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/network/create-api-keys`;
    }
    return '';
  }

  static getWorkSpaceStatsUrl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/dashboard/account-stats`;
    }
    return '';
  }

  static getCliApiList(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/network/cli/list-cli-apis`;
    }
    return '';
  }

  static getUserInfo(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/dashboard/user-info`;
    }
    return '';
  }

  static getProtocolList(type: string): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/protocol/list?list=${type}`;
    }
    return '';
  }

  static getAdditionalProtocolList(type?: string): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      let apiURL = `${url}/protocol/additional/list`;
      if (type) {
        apiURL += `?type=${type}`;
      }
      return apiURL;
    }
    return '';
  }

  static getCheckoutData(id: string | number): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/checkout/${id}`;
    }
    return '';
  }

  static _getKeyValue_ = (key: string) => (obj: Record<string, any>) => obj[key];

  static getSelectProtocolUrl(protocolType: string = '', nodeType: string = '', frontendBaseSuburl: string = ''): string {
    if (protocolType === 'public') {
      if (nodeType === 'full') {
        return BaseUrls.getPlatformDedicatedFullNodesUrl();
      }
      return BaseUrls.getPlatformDedicatedValidatorNodesUrl();
    }
    return frontendBaseSuburl;
  }

  static getSubscriptions(): string {
    const toMarketplace: string = BaseUrls.getMarketplaceUrl();
    return toMarketplace;
  }

  /**
     * subscription  URLs
     */
  static getSubscriptionSummary(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/subscriptions/summary`;
    }
    return '';
  }

  static getSubcriptionUpdateUrl(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/subscriptions/update`;
    }
    return '';
  }

  static getActiveFullNode(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/network/all?list=dedicated`;
    }
    return '';
  }

  static getActiveValidatorNode(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/network/all?list=staking`;
    }
    return '';
  }

  static getplanCalculatorUrl(): string {
    const url: string = BaseUrls.getplanCalculatorUrl();
    return url;
  }

  static getSubgrapDashboardURL(): string {
    if (globalConfig.config) {
      return `${globalConfig.config.subgraphEndpoint}/dashboard`;
    }
    return '';
  }

  static getallPlanUrl(): string {
    const url: string = BaseUrls.getAllPlanUrl();
    return url;
  }

  static getNodeConfiguration(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/configuration/node`;
    }
    return '';
  }

  static getEndpointConfiguration(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/configuration/endpoint`;
    }
    return '';
  }

  static getPlans(serviceType?: string): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      if (serviceType) {
        return `${url}/subscriptions/prices?serviceType=${serviceType}`;
      }
      return `${url}/subscriptions/prices`;
    }
    return '';
  }

  static getSubscription(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      return `${BASE_URL}/subscriptions/subscribe`;
    }
    return '';
  }

  /**
     * Config  URLs
     */
  static getCordaUrl(): string {
    if (globalConfig.config) {
      return globalConfig.config.cordaFrontendUrl;
    }
    return '';
  }

  static getCordaEnterpriseUrl(): string {
    if (globalConfig.config) {
      return globalConfig.config.cordaEnterpriseFrontendtUrl;
    }
    return '';
  }

  static getFabricUrl(): string {
    if (globalConfig.config) {
      return globalConfig.config.fabricFrontendUrl;
    }
    return '';
  }

  static getEnvironment(): string {
    if (globalConfig.config) {
      return globalConfig.config.environment;
    }
    return '';
  }

  static cordaFrontend(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.protocolDefaultUrl;
      return url;
    }
    return '';
  }

  static getItemCode(code: string): string {
    if (globalConfig.config) {
      const { itemCode } = globalConfig.config;
      return itemCode[code];
    }
    return '';
  }

  static getItemCodes(): { [key: string]: string } {
    if (globalConfig.config) {
      const { itemCode } = globalConfig.config;
      return itemCode;
    }
    return {};
  }

  /**
     * ZDFS API URLs
     */
  static getZvaultUrl(): string {
    if (globalConfig.config) {
      return globalConfig.config.zvaultUrl ? globalConfig.config.zvaultUrl : '';
    }
    return '';
  }

  static getGatewayList(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.zvaultBackendUrl;
      return `${url}/api/v1/cluster/list-name`;
    }
    return '';
  }
  /**
     * Endpoint API URLs
     */

  static getAllEndpointList(offset?: number, limit?: number): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      if (limit) return `${url}/endpoint/all?limit=${limit}&offset=${offset}`;
      return `${url}/endpoint/all`;
    }
    return '';
  }

  static protocolNetworkTypes(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/endpoint/service-types`;
    }
    return '';
  }

  static getCreateEndpointUrl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/endpoint`;
    }
    return '';
  }

  static getSupportedProtocols(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/endpoint/supported-protocols`;
    }
    return '';
  }

  static getProtocolContactUsUrl(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/protocol/contact-us`;
    }
    return '';
  }

  static getZdexerURL(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.zdexerPortalUrl;
      return url;
    } return '';
  }

  // public protocolapi

  static getPlansData(planCode: string): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/protocol/additional/price/${planCode}`;
    }
    return '';
  }

  static createSubscription(): string {
    if (globalConfig.config) {
      const url = BaseUrls.getApplicationBackendUrl();
      return `${url}/protocol/additional/subscribe`;
    }
    return '';
  }

  // app frontend url
  static getDashboardUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/dashboard`;
    }
    return '';
  }

  static getWorkspaceUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/workspace`;
    }
    return '';
  }

  static getMyAccountUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/Account`;
    }
    return '';
  }

  static getMarketplaceUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/marketplace`;
    }
    return '';
  }

  static getAllNetworkUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/allNetwork`;
    }
    return '';
  }

  static getAllStakingNetworkUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/network/staking-nodes`;
    }
    return '';
  }

  static getAllEndpointUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/endpoints`;
    }
    return '';
  }

  static getEndpointBuyUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.appFrontendUrl;
      return `${url}/endpoint/buy`;
    }
    return '';
  }

  static getDocsUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = config.multi_tenant_domains.zeeve.redirections.docs;
    }
    return url;
  }

  static getZdfsPurchaseUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.zdfsUrl;
      return `${url}/purchase-subscription`;
    }
    return '';
  }

  static getZdfsManageUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.zdfsUrl;
      return url;
    }
    return '';
  }

  static getPolygonCDKUrl(): string {
    if (globalConfig.config) {
      const url = globalConfig.config.polygonUrl;
      return url;
    }
    return '';
  }

  static getSubgraphUrl(service: 'manage-service' | 'buy-service'): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      // getting url based on the section name
      url = service === 'manage-service'
        ? `${config.subgraphUrl}/dashboard`
        : `${config.appFrontendUrl}/indexing-protocol/buy`;
    }

    return url;
  }

  static getContactDetails(): { email: string; helpdeskURL: string } {
    if (globalConfig.config) {
      const { email, helpdeskURL } = globalConfig.config.multi_tenant_domains.zeeve.contacts;
      return { email, helpdeskURL };
    }
    return { email: '', helpdeskURL: '' };
  }

  static getVideosUrl(): string {
    let url = '';
    const { config } = globalConfig;
    if (config) {
      url = config.videosUrl;
    }
    return url;
  }

  static organizationListUrl(): string {
    if (globalConfig.config) {
      const BASE_URL = BaseUrls.getApplicationBackendUrl();
      console.log('from organizationList');
      const baseurl = `${BASE_URL}/organization/list`;
      return baseurl;
    }
    return '';
  }
}
export default Urls;
